import { call, put } from 'redux-saga/effects';
import { ACTIONS, API_URL, STORAGE } from '../../_config'
import { CallApi } from './api/callApi';
const API_BASE_URL = process.env.REACT_APP_API_URL;

export function* createTransaction(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.POST, API_URL.PAYMENT.CREATE_TRANSACTION, data, true);
        //  console.log('GET BENIFITS',resp)
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* getTransaction(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, API_URL.PAYMENT.GET_TRANSACTION, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* getUserTransaction(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, API_URL.PAYMENT.GET_USER_TRANSACTION, data, true);
        // console.log('GET TRAnction',resp)
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}